import { Box, Skeleton, Stack } from '@mantine/core';

interface ChartSkeletonProps {
  height?: number;
  rows?: number;
  columns?: number;
}

/**
 * Skeleton for chart components during loading/streaming states.
 * Shows a chart-like shape with axis hints.
 */
export function ChartSkeleton({ height = 200, rows: _rows, columns: _columns }: ChartSkeletonProps) {
  return (
    <Stack gap="xs">
      <Box pos="relative" style={{ height }}>
        <Skeleton animate height="100%" radius="sm" />
        <Box
          pos="absolute"
          style={{
            bottom: 8,
            left: 8,
            right: 8,
            height: 2,
            backgroundColor: 'var(--mantine-color-dark-4)',
            opacity: 0.5,
          }}
        />
        <Box
          pos="absolute"
          style={{
            bottom: 8,
            left: 8,
            top: 8,
            width: 2,
            backgroundColor: 'var(--mantine-color-dark-4)',
            opacity: 0.5,
          }}
        />
      </Box>
      <Skeleton animate height={16} radius="sm" width="60%" />
    </Stack>
  );
}
